import api from './interceptor';

const BASE_URL_V2 = 'api/v2/reasons-for-visit';

export default {

  // API Version 2
  getUrgentReasonsForVisit: (clinicId) => api.get(`${BASE_URL_V2}/${clinicId}/urgent`),
  saveUrgentReasonsForVisit: (clinicId, params) => api.post(`${BASE_URL_V2}/${clinicId}/urgent`, params),
  getGlobeMedReasonsForVisit: (clinicId, type) => api.get(`${BASE_URL_V2}/${clinicId}/insurance?type=${type}`),
};
